import { logFeatureEvent, LogLevel } from '@lib/logFeatureEvent';

export const logAiNotesAction = (action: string, level: LogLevel = 'INFO', details?: Record<string, unknown>) => {
  void logFeatureEvent('ai-notes', {
    logs: [
      {
        timestampMs: Date.now(),
        logLevel: level,
        message: JSON.stringify({
          action,
          ...details
        })
      }
    ]
  }).catch((error) => {
    console.warn('Failed to send AI Notes FE log', error);
  });
};
